import { render, staticRenderFns } from "./tabbed-view-tabs.vue?vue&type=template&id=791adf10&scoped=true&"
import script from "./tabbed-view-tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./tabbed-view-tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./tabbed-view-tabs.vue?vue&type=style&index=0&id=791adf10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791adf10",
  null
  
)

export default component.exports